import accordion from './accordion';
// import contactBar from './contact-bar';
import theTree from './the-tree';
import scroll from './scroll';
import scrollToDiv from './scroll-to-div';
import isInViewPort from './is-in-viewport';
import form from './form';
import hero from './hero';

function init() {
  isInViewPort();
  accordion();
  // contactBar();
  theTree();
  scroll();
  scrollToDiv();
  hero();
  form();
}

export default {
  init,
};
